import cmp from './DrawerNavigation'

export default cmp
